<template>
  <!-- 遮罩 begin -->
  <MaskLayer
    class="position-absolute"
    style="max-height: 100%"
  >
    <!-- 獎品名稱 begin -->
    <div
      class="bg-white p-3 px-md-4 d-flex flex-column rounded-md text-center"
      style="width: 90%; max-width: 560px; max-height: 95vh"
    >
      <h5
        v-if="item.isPrize"
        class="font-weight-normal"
      >
        {{ $t("activity.congratuation-on-getting") }}
      </h5>
      <!-- 禮品-上稿 begin -->
      <h2 class="font-weight-normal">
        {{ item.itemInfo.name }}
      </h2>
      <!-- 禮品-上稿 end -->
      <!-- 禮品-預覽 begin -->
      <div class="m-auto image-panel image-panel-5 bg-none my-2">
        <img
          :src="item.itemInfo.image"
          alt=""
        >
      </div>
      <div
        v-if="awardType === 4"
        class=" font-size-md text-gray600"
      >
        {{ $t("activity.activityaward-popup-error") }}
      </div>
      <!-- 禮品-預覽 end -->
      <div>
        <b-button
          pill
          :style="{
            background: `rgba(${entertainmentInfo.resultColor}, 0.75)`,
            'border-color': `rgba(${entertainmentInfo.resultColor}, 1.0)`,
            color: `rgba(${
              entertainmentInfo.resultColor === '255,255,255'
                ? '45,167,193'
                : '255,255,255'
            },1.0)`,
          }"
          class="my-3 w-100"
          @click="confirm"
        >
          {{ buttonWording }}
        </b-button><!-- 行動呼籲按鈕, 形狀：pill/空值/squared -->
      </div>
    </div>
    <!-- 獎品名稱 end -->
  </MaskLayer>
  <!-- 遮罩 end -->
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import MaskLayer from '@/components/MaskLayer.vue';

export default {
  components: {
    MaskLayer,
  },
  props: {
    // 中獎商品資訊
    item: {
      type: Object,
      require: true,
    },
    // 活動資料
    activity: {
      type: Object,
      required: true,
    },
    awardType: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters(['hasForm']),
    ...mapState(['AwardInformation', 'isReceivingFormComplete']),
    // 娛樂活動資料(刮刮樂...)
    entertainmentInfo() {
      const vm = this;
      switch (vm.activity.categoryID) {
        // 刮刮樂
        case 'Scratchoff':
          return vm.activity.scratchOffInfo;
        // 拉霸
        case 'Slot':
          return vm.activity.slotInfo;
        case 'Roulette':
          return vm.activity.rouletteInfo;
        default:
          return {};
      }
    },
    buttonWording() {
      if (this.awardType === 1) {
        return this.hasForm() ? this.$t('global.fill-award-information') : this.$t('global.complete');
      }

      return this.$t('global.confirm');
    },
  },
  methods: {
    ...mapMutations(['set']),
    // 確定按鈕
    confirm() {
      if (this.awardType === 1) {
        if (this.hasForm()) {
          this.set({ name: 'isReceivingFormComplete', value: false });
          this.set({ name: 'showForm', value: true });
        }
      }
      this.$emit('confirm');
    },
  },
};
</script>
